(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["os-promo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('os-sale-indicator')) {
  customElements.define('os-sale-indicator', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.animation === 'played' || !('IntersectionObserver' in window)) return;
      this.dataset.animation = 'pending';
      this.observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.dataset.animation = 'played';
        this.observer.disconnect();
      }, { threshold: 0.5 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
